import axios from 'axios';

export function getAdminLegalDocuments(token) {
    return axios.get(`${process.env.REACT_APP_API_URL}/admin/legalDocuments`, {
        headers: {
            Authorization: `${token}`
        }
    });
}
